import * as themeColors from "@assets/styles/colors.module.scss";
const colors = ["None", ...Object.keys(themeColors)];
import SeoCopy from "@/components/SeoCopy.vue";

export const seoCopyInit = {
    component: SeoCopy,
    name: "SeoCopy",
    models: ["category-landing-content", "content-section"],
    inputs: [
        // text
        {
            name: "seoText",
            type: "richText"
        },
        // text color
        {
            name: "text_color",
            friendlyName: "Text Color",
            type: "string",
            enum: colors,
        },
        // bg color
        {
            name: "bg_color",
            friendlyName: "Background Color",
            type: "string",
            enum: colors,
        },
    ]
};
